import SeoJsonLd from "@/components/feature/SeoJsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "社会福祉法人 功有会",
  alternateName: "みどり苑",
  url: siteUrl,
  logo: `${siteUrl}/favicon.png`,
  description:
    "奈良県を拠点とする社会福祉法人。高齢者・障がい者・児童への福祉サービスを18施設・18サービスで展開しています。",
  address: {
    "@type": "PostalAddress",
    addressRegion: "奈良県",
    addressCountry: "JP",
  },
  areaServed: {
    "@type": "AdministrativeArea",
    name: "奈良県",
  },
  sameAs: [],
};

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "みどり苑｜社会福祉法人 功有会",
  url: siteUrl,
  description:
    "奈良県の社会福祉法人 功有会が運営するみどり苑。高齢者・障がい者・児童への福祉サービスを提供。",
  inLanguage: "ja",
  publisher: {
    "@type": "Organization",
    name: "社会福祉法人 功有会",
  },
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "みどり苑｜社会福祉法人 功有会",
  description:
    "奈良県を拠点とする社会福祉法人 功有会が運営するみどり苑。高齢者・障がい者・児童への福祉サービスを18施設・18サービスで展開。あなたのよりどころとして、温かみのある支援を提供しています。",
  url: siteUrl,
  logo: `${siteUrl}/favicon.png`,
  address: {
    "@type": "PostalAddress",
    addressRegion: "奈良県",
    addressCountry: "JP",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 34.6851,
    longitude: 135.8048,
  },
  areaServed: "奈良県",
  serviceType: ["高齢者介護", "障がい者支援", "児童福祉"],
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "みどり苑ではどのような福祉サービスを提供していますか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "みどり苑（社会福祉法人 功有会）では、高齢者・障がい者・児童を対象とした福祉サービスを18施設・18サービスで展開しています。介護・支援・保育など幅広いサービスをご提供しています。",
      },
    },
    {
      "@type": "Question",
      name: "みどり苑はどこにありますか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "みどり苑（社会福祉法人 功有会）は奈良県を拠点として活動しています。詳しい施設の所在地はお問い合わせください。",
      },
    },
    {
      "@type": "Question",
      name: "採用情報はありますか？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "はい、みどり苑では福祉サービスを支えるスタッフを随時募集しています。採用情報セクションよりご確認ください。",
      },
    },
  ],
};

const HomeSeo = () => (
  <>
    <SeoJsonLd data={organizationSchema} id="jsonld-organization" />
    <SeoJsonLd data={webSiteSchema} id="jsonld-website" />
    <SeoJsonLd data={localBusinessSchema} id="jsonld-localbusiness" />
    <SeoJsonLd data={faqSchema} id="jsonld-faq" />
  </>
);

export default HomeSeo;
